import React from "react";
import { Table } from "semantic-ui-react";

const OntologyClassesTable = ({ classes }) => (
  <div className="ontology-classes-table">
    <p>The following ontology classes are associated with this term:</p>
    <Table compact>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>ID</Table.HeaderCell>
          <Table.HeaderCell>Label</Table.HeaderCell>
          <Table.HeaderCell>Definition</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {classes.map((cls) => (
          <Table.Row key={`tooltip-${cls.id}`}>
            <Table.Cell>
              <strong>{cls.id}</strong>
            </Table.Cell>
            <Table.Cell>{cls.formal_label}</Table.Cell>
            <Table.Cell>{cls.definition}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  </div>
);

export default OntologyClassesTable;
